module.exports = __webpack_public_path__ + "static/media/safari-pinned-tab.ea3c6da5.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/adbop-favicon/safari-pinned-tab.svg
// module id = 281
// module chunks = 0